// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__33fmr","ranges":"BmiRanges_ranges__1s6jL"};